export default {
	/**
	 * Function getActions - gets an action list to execute against for the screening orders
	 *
	 * @param {*} item Order returned from order list
	 */
	getActions(item) {
		return [
			{
				name: 'view-order',
				title: `View ${item.applicant.name} Screen`,
				icon: 'mdi-clipboard-account',
				permission: 'orders.view',
			},
			{
				name: 'download-pdf',
				title: 'Download PDF',
				icon: 'mdi-file-pdf',
				permission: 'orders.view',
			},
			{
				name: 'send-fax',
				title: `Send Fax to ${item.property?.contact?.name}`,
				icon: 'mdi-fax',
				permission: 'orders.view',
			},
			{
				name: 'share-link',
				title: `Share Screening Link`,
				icon: 'mdi-share-variant',
				permission: 'orders.view',
			},
			{
				divider: true,
				permission: 'orders.resubmit',
			},
			{
				name: 'resubmit-order',
				title: `Resubmit Order`,
				icon: 'mdi-account-reactivate',
				permission: 'orders.resubmit',
				class: 'error--text text--darken-2',
			},
		]
	},
}
